import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {isApiResponseOk, normalize, normalizedUpdate} from '../../util/utils';
import {HttpStatusCodes, updateAnnotationAction} from '../../util/uiconstants';

const viewKey = 'ACCOUNT_BODY_DOCUMENT';

export default function entityDocumentReducer(state = initialState.entityDocuments, action) {
	let newState;

	switch (action.type) {
		case types.GET_ENTITY_DOCUMENTS:
			if (action.response && action.response.data) {
				return normalize(action.response.data, undefined);
			}
			return state;
		case types.UPDATE_DOCUMENT: {
			if (action.viewKey === viewKey && !action.error) {
				return {
					...state,
					byId: {
						...state.byId,
						[action.documentId]: {
							...state.byId[action.documentId],
							...action.meta.api.data
						}
					}
				};
			}
			return state;
		}
		case types.DELETE_DOCUMENT_BY_ID: {
			if (action.viewKey === viewKey && !action.error) {
				const updatedById = {...state.byId};

				delete updatedById[action.documentId];

				return {
					...state,
					byId: updatedById,
					allIds: state.allIds.filter((id) => id !== action.documentId)
				};
			}
			return state;
		}
		case types.SET_ENTITY_DOCUMENT_NAME: {
			if (action.response && action.response) {
				return {
					...state,
					byId: {
						...state.byId,
						[action.documentId]: {
							...state.byId[action.documentId],
							documentName: action.newDocumentName
						}
					}
				};
			}
			return state;
		}
		case types.ADD_ENTITY_DOCUMENT_SIGNOFF: {
			if (!action.error) {
				return {
					...state,
					byId: {
						...state.byId,
						[action.documentId]: {
							...state.byId[action.documentId],
							approvals: [...state.byId[action.documentId].approvals, action.documentSignoff]
						}
					}
				};
			}
			return state;
		}
		case types.REMOVE_ENTITY_DOCUMENT_SIGNOFF: {
			if (!action.error) {
				return {
					...state,
					byId: {
						...state.byId,
						[action.documentId]: {
							...state.byId[action.documentId],
							approvals: state.byId[action.documentId].approvals.filter((approval) => approval.id !== action.approvalId)
						}
					}
				};
			}
			return state;
		}
		case types.CREATE_ENTITY_FORM: {
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				newState = {...state};
				if (action.response?.length > 0) {
					action.response.forEach((item) => {
						newState = normalize([item.document], 'id', newState);
					});
				}
				return newState;
			}
			return state;
		}
		case types.UPDATE_ENTITY_DOCUMENT_RELATE: {
			if (isApiResponseOk(action)) {
				const {documentId, stEntityId} = action.response;
				newState = {...state};

				let updatedDocument = {...newState.byId[documentId]};
				updatedDocument.entities = updatedDocument.entities.concat({id: stEntityId});

				newState = normalizedUpdate(documentId, updatedDocument, newState);
			}

			return state;
		}
		case types.DELETE_ENTITY_DOCUMENT_RELATE: {
			if (isApiResponseOk(action)) {
				const {documentId, stEntityId} = action;
				newState = {...state};

				let updatedDocument = {...newState.byId[documentId]};
				updatedDocument.entities = updatedDocument.entities.filter((ent) => ent.id !== stEntityId);

				newState = normalizedUpdate(documentId, updatedDocument, newState);
			}

			return state;
		}

		case types.POST_RNH_NEW_NOTE: {
			if (isApiResponseOk(action)) {
				const {documentId} = action.meta.api.data;
				newState = {...state};

				let updatedDocument = {...newState.byId[documentId]};
				updatedDocument.engagementReviewNoteCount++;

				newState = normalizedUpdate(documentId, updatedDocument, newState);
				return newState;
			}

			return state;
		}

		case types.UPDATE_RNH_NOTE_DETAIL: {
			if (isApiResponseOk(action)) {
				const {updateAction} = action.data;
				if (updateAction === updateAnnotationAction.bulkStatusUpdate) {
					const {documentId, statusIdChanged, isOpening} = action.data;
					newState = {...state};
					let updatedDocument = {...newState.byId[documentId]};

					if (statusIdChanged && isOpening) {
						updatedDocument.engagementReviewNoteCount++;
					} else {
						updatedDocument.engagementReviewNoteCount--;
					}

					newState = normalizedUpdate(documentId, updatedDocument, newState);
					return newState;
				}
			}

			return state;
		}

		case types.CLEAR_ENTITY_DOCUMENTS:
			return initialState.entityDocuments;
		default:
			return state;
	}
}
